import { render, staticRenderFns } from "./TOSCheckbox.vue?vue&type=template&id=61b7e592&scoped=true&"
import script from "./TOSCheckbox.vue?vue&type=script&lang=ts&"
export * from "./TOSCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./TOSCheckbox.vue?vue&type=style&index=0&id=61b7e592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7e592",
  null
  
)

export default component.exports